<template>
  <div class="auto-tasks-form">
    <el-form ref="monitorForm" class="ghost-button-styles" :model="monitor" :rules="rules" label-width="100px">
      <el-form-item label="媒体" prop="mediaId">
        <el-radio-group v-model="monitor.mediaId" @change="changeMedia">
          <el-radio-button ghost :label="10" :disabled="editState">巨量引擎2.0</el-radio-button>
          <el-radio-button ghost :label="16" :disabled="editState">腾讯3.0</el-radio-button>
          <el-radio-button ghost :label="32" :disabled="editState">磁力引擎</el-radio-button>
          <el-radio-button ghost :label="45" :disabled="editState">百度信息流</el-radio-button>
          <el-radio-button ghost :label="6" :disabled="editState">超级汇川</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="规则名称" prop="name">
        <el-input v-model="monitor.name" style="width: 320px" placeholder="最大60个字符，1个中文等于2个字符"></el-input>
      </el-form-item>

      <el-form-item label="范围类型" prop="rangeType" required>
        <el-radio-group v-model="monitor.rangeType" @change="onRangeTypeChange">
          <el-radio-button ghost :label="RANGE_TYPES.ACCOUNT_LEVEL" :disabled="editState">账号级</el-radio-button>
          <el-radio-button ghost v-if="access.includes('M21180')" :label="RANGE_TYPES.APP_LEVEL" :disabled="editState">
            应用级
          </el-radio-button>
        </el-radio-group>
      </el-form-item>

      <template v-if="monitor.rangeType === RANGE_TYPES.APP_LEVEL">
        <el-form-item label="游戏选择">
          <el-radio-group v-model="monitor.ruleTypeInfo.gameType">
            <el-radio-button ghost v-for="item in GAME_TYPE_LIST" :key="item.value" :label="item.value">
              {{ item.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item prop="game">
          <div class="selector">
            <div class="lists">
              <el-input class="search-box" v-model="gameSearchString" clearable></el-input>
              <div class="checkbox-wrapper">
                <el-checkbox-group v-if="monitor.ruleTypeInfo.gameType === 1" v-model="monitor.ruleTypeInfo.mgameIds">
                  <div class="checkbox-item" v-for="item in gameData.middleware" :key="item.id">
                    <el-checkbox :label="item.id">{{ item.name }}</el-checkbox>
                  </div>
                </el-checkbox-group>

                <el-checkbox-group v-else-if="monitor.ruleTypeInfo.gameType === 2" v-model="monitor.ruleTypeInfo.gameGroupIds">
                  <div class="checkbox-item" v-for="item in gameData.group" :key="item.groupId">
                    <el-checkbox :label="item.id">{{ item.name }}</el-checkbox>
                  </div>
                </el-checkbox-group>

                <el-checkbox-group v-else v-model="monitor.ruleTypeInfo.gameIds">
                  <div class="checkbox-item" v-for="item in gameData.game" :key="item.id">
                    <el-checkbox :label="item.id">{{ item.name }}</el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
            </div>
            <ResultBlock
              v-model="gameResultTab"
              :results="gameResults"
              :radios="gameRadios"
              @remove-all="onRemoveAllResult('game')"
              @remove-item="onRemoveGameItem"
            ></ResultBlock>
          </div>
        </el-form-item>
      </template>

      <el-form-item label="账号计划" v-if="monitor.rangeType === RANGE_TYPES.ACCOUNT_LEVEL">
        <el-button @click="selectAccount">
          <span v-if="lockLen || planLen || excludePlanLen">
            已锁定{{ lockLen }}个账号，定向{{ planLen }}个计划，排除{{ excludePlanLen }}个计划
          </span>
          <span v-else>请先选择账号计划</span>
          <i class="el-icon-arrow-down"></i>
        </el-button>
      </el-form-item>

      <el-form-item label="规则类型">
        <el-radio-group v-model="monitor.ruleType" @change="setRuleInfo">
          <el-radio-button ghost :label="RULE_TYPES.PLAN_DISABLE" :disabled="editState">暂停计划</el-radio-button>
          <el-radio-button ghost :label="RULE_TYPES.PLAN_ENABLE" :disabled="editState">启用计划</el-radio-button>
          <template v-if="monitor.rangeType === RANGE_TYPES.ACCOUNT_LEVEL">
            <el-radio-button ghost :label="RULE_TYPES.PLAN_BUDGET" :disabled="editState">更改预算</el-radio-button>
            <el-radio-button ghost :label="RULE_TYPES.PLAN_PRICE" :disabled="[6].includes(monitor.mediaId) || editState">
              更改出价
            </el-radio-button>
            <el-radio-button ghost :label="RULE_TYPES.PLAN_DELETE" :disabled="editState">删除计划</el-radio-button>
            <el-radio-button ghost :label="RULE_TYPES.PLAN_COPY" :disabled="[6, 32, 45, 10].includes(monitor.mediaId) || editState">
              复制计划
            </el-radio-button>
            <el-radio-button ghost :label="RULE_TYPES.PLAN_MESSAGE" :disabled="editState">仅消息提醒</el-radio-button>
            <el-radio-button ghost :label="RULE_TYPES.MATERIAL_DISABLE" :disabled="[10].includes(monitor.mediaId) || editState">
              暂停素材
            </el-radio-button>
            <el-radio-button ghost :label="RULE_TYPES.MATERIAL_ENABLE" :disabled="[10].includes(monitor.mediaId) || editState"
              >启用素材
            </el-radio-button>
          </template>
        </el-radio-group>
      </el-form-item>

      <el-form-item prop="ruleTypeInfo">
        <rule-config
          v-if="[3, 4].includes(monitor.ruleType)"
          v-model="monitor.ruleTypeInfo"
          :type="monitor.ruleType"
          :disabled="editState"
        />
      </el-form-item>

      <el-form-item label="触发条件" prop="monitorCondition" required>
        <condition v-model="monitor.monitorCondition" :data="ruleData"></condition>
      </el-form-item>

      <el-form-item label="数据范围">
        <el-radio-group v-model="monitor.dataRange">
          <el-radio-button ghost :label="1">今日实时</el-radio-button>
          <el-radio-button ghost :label="2">近2天（含今日）</el-radio-button>
          <el-radio-button ghost :label="3">近3天（含今日）</el-radio-button>
          <el-radio-button ghost :label="5">近5天（含今日）</el-radio-button>
          <el-radio-button ghost :label="7">近7天（含今日）</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="监测频率" prop="monitorTime">
        <div style="display: flex; align-items: center">
          <el-radio-group v-model="monitorTime" vertical>
            <el-radio label="fiveMin">每5分钟</el-radio>
            <el-radio :disabled="monitor.rangeType === RANGE_TYPES.APP_LEVEL" label="quarter">每15分钟</el-radio>
            <el-radio :disabled="monitor.rangeType === RANGE_TYPES.APP_LEVEL" label="half">每半小时</el-radio>
            <el-radio :disabled="monitor.rangeType === RANGE_TYPES.APP_LEVEL" label="day">每天</el-radio>
          </el-radio-group>
          <span>&ensp;</span>
          <el-select v-model="daytime" :disabled="monitorTime !== 'day'">
            <el-option v-for="(time, index) in times" :key="index" :value="time" :label="time"></el-option>
          </el-select>
        </div>
      </el-form-item>

      <el-form-item label="提醒方式" prop="emailFlag">
        <el-checkbox-group v-model="monitor.emailFlag">
          <el-checkbox-button v-for="item in RECIEVE_TYPES_LIST" :key="item.value" :label="item.value" ghost>
            {{ item.label }}
          </el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>

      <ElFormItem v-if="showUsersInput" label="选择人员" prop="sendOpIds">
        <el-select v-model="monitor.sendOpIds" style="width: 100%" filterable multiple clearable>
          <el-option v-for="item in SYS_USERS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
        <p style="color: red; font-size: 12px">默认提醒计划新建人</p>
      </ElFormItem>

      <ElFormItem v-if="showWebhookInput" label="钉钉群消息" prop="webhook">
        <div class="webhooks">
          <div class="url-input" v-for="(group, idx) in dingWebhooks" :key="idx">
            <el-input v-model="group.url" placeholder="webhook链接"></el-input>
            <i class="close el-icon-error" v-if="webhookUrlLen > 1" @click="removeUrlItem(idx)"></i>
          </div>

          <div class="add-row">
            <el-button type="text" :disabled="webhookUrlLen >= 10" @click="addWebhookUrl">+添加链接</el-button>
            <p>({{ webhookUrlLen }}/10)</p>
            <p>消息通过钉钉群机器人发送，添加群机器人对应的Webhook链接，设置关键词 <span style="color: red">“智能自动化”</span></p>
          </div>
        </div>
      </ElFormItem>

      <el-form-item>
        <el-button @click.stop="cannel">取消</el-button>
        <el-button type="primary" v-if="editState" :loading="loading" @click.stop="save">
          <span v-if="!loading">保存规则</span>
          <span v-else>提交中...</span>
        </el-button>
        <el-button type="primary" v-else :loading="loading" @click.stop="submit">
          <span v-if="!loading">新增规则</span>
          <span v-else>提交中...</span>
        </el-button>
      </el-form-item>
    </el-form>

    <select-modal
      v-model="model"
      :data="accounData"
      :include-data="includeData"
      :exclude-data="excludeData"
      :preload="preload"
      :loading="selecting"
      :media="monitor.mediaId"
      :plan-ids="planIds"
      :exclude-plan-ids="excludePlanIds"
      :lock-len="lockLen"
      :plan-len="planLen"
      :exclude-plan-len="excludePlanLen"
      @on-select="selectAll"
      @on-change="model = false"
    />
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import times from '@/components/crontab/times'
import filterAdds from '../data/filters_add'
import validMixin from '../mixins/valid-mixin'
import { mul, div } from '@/common/js/api'
import { isArray, isEmpty, getIdOfData, timeout, deepCopy, findCheckChild } from '@/common/js/utils'
import { adAccount } from '@/api/common.model'
import { getAdTreeList, createAutoRule, editAutoRule, getAutoRuleDetail } from '@/api/manage.model'
import SelectModal from './components/selecter/select-modal'
import Condition from '@/components/condition/condition.vue'
import ResultBlock from '@/views/tools/datareportcontrol/components/transfer-selector.vue'
import ErrorPop from '@/components/error-pop.vue'
// 引入新组件
import RuleConfig from './components/rule-config.vue'
import { ruleTypeEnum, RULE_TYPES, RANGE_TYPES } from './consts.js'

import { initPageData, MEDIA_ACCOUNTS, GAME_GROUPS, POPULAR_GAMES, MEDIAS, MID_GAMES, SYS_USERS } from '@/data/global-opts'

const PAGE_REQUIRED_OPTS = initPageData([GAME_GROUPS, SYS_USERS, MID_GAMES, POPULAR_GAMES])

const GAME_TYPE_LIST = [
  { label: '中间件游戏', value: 1, key: 'mgameIds' },
  { label: '游戏组', value: 2, key: 'gameGroupIds' },
  { label: '游戏', value: 3, key: 'gameIds' }
]
const RECIEVE_TYPES = {
  DING: '1',
  EMAIL: '2',
  DING_GROUP: '3'
}
const RECIEVE_TYPES_LIST = [
  { value: RECIEVE_TYPES.DING, label: '个人钉钉' },
  { value: RECIEVE_TYPES.EMAIL, label: '邮箱' },
  { value: RECIEVE_TYPES.DING_GROUP, label: '钉钉群' }
]

const getRuleInfoForm = () => {
  return {
    itemType: 1,
    value: '',
    valueType: 1,
    frequencyTotal: 1,
    frequencyType: 1,
    upperLimit: '',
    gameType: 1,
    gameIds: [],
    gameGroupIds: [],
    mgameIds: []
  }
}
export default {
  name: 'monitoradd',
  mixins: [validMixin],
  components: {
    Condition,
    SelectModal,
    // ErrorPop,
    RuleConfig, // 注册新组件
    ResultBlock
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    GAME_TYPE_LIST() {
      return GAME_TYPE_LIST
    },
    RANGE_TYPES() {
      return RANGE_TYPES
    },
    RULE_TYPES() {
      return RULE_TYPES
    },
    RECIEVE_TYPES_LIST() {
      return RECIEVE_TYPES_LIST
    },
    access() {
      return this.$store.state.accessAuth || []
    },
    title() {
      return this.editState ? '修改自动规则' : '新增自动规则'
    },
    editState() {
      return this.$route.query.t === 'edit'
    },
    lockLen() {
      return this.accounData.filter((ret) => ret.check).length
    },
    planLen() {
      return findCheckChild(this.includeData).filter((ret) => ret.plan).length
    },
    excludePlanLen() {
      return findCheckChild(this.excludeData).filter((ret) => ret.plan).length
    },
    ruleData() {
      return filterAdds.filter((f) => !isArray(f.unShow) || !f.unShow.includes(this.monitor.mediaId))
    },
    subMediaId() {
      const { mediaId } = this.monitor
      if (mediaId === 10) {
        return 2
      }
      if (mediaId === 16) {
        return 3
      }
      return 1
    },
    /**
     * @description: 根据筛选条件获取游戏数据
     */
    gameData() {
      const str = this.gameSearchString
      return {
        middleware: this.MID_GAMES.filter((m) => m.name.includes(str)),
        group: this.GAME_GROUPS.filter((m) => m.name.includes(str)),
        game: this.POPULAR_GAMES.filter((m) => m.name.includes(str))
      }
    },
    /**
     * @description: 游戏已选结果，根据已选id获取json
     */
    gameResults() {
      const { mgameIds, gameGroupIds, gameIds } = this.monitor.ruleTypeInfo
      switch (this.gameResultTab) {
        case 1:
          return this.MID_GAMES.filter((m) => mgameIds.includes(m.id))
        case 2:
          return this.GAME_GROUPS.filter((m) => gameGroupIds.includes(m.id))
        case 3:
          return this.POPULAR_GAMES.filter((m) => gameIds.includes(m.id))
        default:
          return []
      }
    },
    /**
     * @description: 游戏类型的radio选项，并且注入每个游戏类型的已选个数
     */
    gameRadios() {
      return GAME_TYPE_LIST.map((m) => {
        const items = this.monitor.ruleTypeInfo[m.key]
        return {
          ...m,
          sum: items?.length || 0
        }
      })
    },
    webhookUrlLen() {
      return this.dingWebhooks.length
    },
    // 个人钉钉、邮箱显示
    showUsersInput() {
      const types = this.monitor.emailFlag
      // const { RECIEVE_TYPES } = DailyReports
      return types.includes(RECIEVE_TYPES.DING) || types.includes(RECIEVE_TYPES.EMAIL)
    },
    // 钉钉群显示
    showWebhookInput() {
      return this.monitor.emailFlag.includes(RECIEVE_TYPES.DING_GROUP)
    }
  },
  methods: {
    getData() {
      getAutoRuleDetail({
        ruleId: this.monitor.ruleId
      })
        .then((data) => {
          if (data) {
            const {
              name,
              mediaId,
              ruleType,
              dataRange,
              rangeType = RANGE_TYPES.ACCOUNT_LEVEL,
              emailFlag,
              sendOpIds,
              monitorTime,
              monitorCondition,
              rulePlanJson,
              ruleTypeInfo,
              webhookConfig
            } = data
            const { key, value } = monitorTime
            const { accountIds, accounts, planIds, excludePlanIds } = rulePlanJson
            const { gameType, gameIds, gameGroupIds, mgameIds } = ruleTypeInfo
            const ruleTypeInfoParams = { ...getRuleInfoForm(), ...ruleTypeInfo }
            if (gameType && rangeType === RANGE_TYPES.APP_LEVEL) {
              ruleTypeInfoParams.gameIds = gameIds?.length && typeof gameIds === 'string' ? gameIds.split(',').map(Number) : []
              ruleTypeInfoParams.gameGroupIds =
                gameGroupIds?.length && typeof gameIds === 'string' ? gameGroupIds.split(',').map(Number) : []
              ruleTypeInfoParams.mgameIds = mgameIds?.length && typeof gameIds === 'string' ? mgameIds.split(',').map(Number) : []
            }

            const emailFlagParams = []
            if (emailFlag === 1) {
              emailFlagParams.push(RECIEVE_TYPES.DING)
            }
            if (emailFlag === 2) {
              emailFlagParams.push(RECIEVE_TYPES.EMAIL)
            }
            if (emailFlag === 3) {
              emailFlagParams.push(RECIEVE_TYPES.DING, RECIEVE_TYPES.EMAIL)
            }
            if (sendOpIds?.length) {
              this.monitor.sendOpIds = sendOpIds.split(',').map(Number)
            }

            if (webhookConfig) {
              const config = webhookConfig.split(',').filter((url) => url.startsWith('http'))
              this.dingWebhooks = config.map((url) => ({ url }))
              emailFlagParams.push(RECIEVE_TYPES.DING_GROUP)
            }

            this.monitor = Object.assign(this.monitor, {
              name,
              mediaId,
              ruleType,
              rangeType,
              dataRange,
              emailFlag: emailFlagParams,
              ruleTypeInfo: ruleTypeInfoParams,
              monitorCondition
            })
            // 监控频率
            key && (this.monitorTime = key)
            this.daytime = value || ''
            // 账号处理
            this.accountIds = this.editState ? accountIds : []
            this.accounts = this.editState ? accounts : []
            this.planIds = this.editState ? planIds : []
            this.excludePlanIds = this.editState ? excludePlanIds : []
            this.preload = this.editState // 如果上面使用空值 preload 要改成false
            this.proloadData(true)
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    setRuleInfo(val) {
      if (val === RULE_TYPES.PLAN_BUDGET || val === RULE_TYPES.PLAN_PRICE) {
        this.monitor.ruleTypeInfo = getRuleInfoForm()
      }

      this.$refs.monitorForm?.clearValidate()
    },
    selectAccount() {
      if (this.accounData.length) this.model = true
      else this.proloadData()
    },
    proloadData(bool) {
      const mediaId = Math.abs(this.monitor.mediaId)
      this.selecting = true
      if (!bool) {
        this.model = true
      }
      const accounts = this.accounts.map((ret) => {
        return getAdTreeList({ mediaId, adAccountId: ret, subMediaId: this.subMediaId })
      })
      Promise.all([adAccount({ mediaId, authFlag: 1 }), ...accounts])
        .then((data) => {
          const [accounData, ...preAccountData] = data
          const preAccountList = preAccountData.reduce((pre, account) => {
            pre.push(account.pop())
            return pre
          }, [])
          if (isArray(accounData)) {
            this.accounData = accounData.map((ret) => {
              const check = isArray(this.accountIds) && this.accountIds.includes(ret.id)
              return { id: ret.id, name: ret.name, value: ret.name, check, children: [] }
            })
            this.includeData = accounData.map((ret) => this.parseAccountData(ret, deepCopy(preAccountList), this.planIds))
            this.excludeData = accounData.map((ret) => this.parseAccountData(ret, deepCopy(preAccountList), this.excludePlanIds))
          }
          this.show = true // 加载动画关闭
          this.selecting = false
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    parseAccountData(ret, preAccountList, planIds) {
      const account = { id: ret.id, name: ret.name, children: [], xhr: false }
      // 修改|复制 处理计划选中
      if (isArray(this.accounts) && this.accounts.includes(ret.id)) {
        const { adGroupList } = preAccountList.filter((met) => met.id === ret.id).pop()
        Object.assign(account, {
          children: adGroupList.map((meta) => {
            return {
              id: meta.adGroup.id,
              name: meta.adGroup.name,
              children: meta.adPlanList.map((t) => {
                t.plan = true
                t.check = isArray(planIds) && planIds.includes(t.id)
                return t
              })
            }
          }),
          xhr: true
        })
      }
      return account
    },
    onRangeTypeChange() {
      this.monitor.ruleType = 1
      this.monitorTime = 'fiveMin'
    },
    // 切换媒体初始化
    changeMedia() {
      this.accounData = []
      this.planIds = []
      this.excludePlanIds = []
      this.accountIds = []
      this.accounts = []
      this.monitor.ruleType = 1
      this.preload = false
    },
    toFloat(key, obj, fixed) {
      if (isEmpty(obj[key])) return
      let val = parseFloat(obj[key])
      if (val < 0) val = 0
      else if (fixed) {
        val = mul(val, 100)
        val = div(Math.floor(val), 100)
      }
      obj[key] = String(val)
    },
    // 全选
    selectAll({ list, check = true, current = '' }) {
      let data
      // 无限递归
      const setAllChecked = (data, check) => {
        data.forEach((ret) => {
          if (ret.children && ret.children.length) setAllChecked(ret.children, check)
          this.$set(ret, 'check', check)
        })
      }
      if (current) {
        const item = getIdOfData(list, current)
        data = item.children
      } else data = list
      setAllChecked(data, check)
    },

    /**
     * @description: 新增webhook链接
     */
    addWebhookUrl() {
      if (this.webhookUrlLen >= 10) return
      this.dingWebhooks.push({ url: '' })
    },
    /**
     * @description: 删除一条hook url
     * @param {*} idx
     */
    removeUrlItem(idx) {
      this.dingWebhooks.splice(idx, 1)
    },

    // 获取表单数据
    getFormData() {
      const accouts = this.accounData.filter((ret) => ret.check).map((ret) => ret.id)
      const include = findCheckChild(this.includeData)
        .filter((ret) => ret.plan)
        .map((ret) => ret.id)
      const exclude = findCheckChild(this.excludeData)
        .filter((ret) => ret.plan)
        .map((ret) => ret.id)

      let params = Object.assign({}, this.monitor, {
        lockAcountIds: accouts,
        planIds: include,
        excludePlanIds: exclude,
        mediaId: Math.abs(this.monitor.mediaId),
        subMediaId: this.subMediaId
      })

      // 监控频率
      const monitorTime = { key: this.monitorTime }
      if (this.monitorTime === 'day') monitorTime.value = this.daytime
      else monitorTime.value = ''
      params = Object.assign(params, { monitorTime })

      // ruleTypeInfo
      if (params.rangeType === RANGE_TYPES.ACCOUNT_LEVEL) {
        const { gameIds, gameGroupIds, mgameIds, gameType, ...restRuleParams } = params.ruleTypeInfo
        params.ruleTypeInfo = { ...restRuleParams }
        if (params.ruleType === RULE_TYPES.PLAN_BUDGET || params.ruleType === RULE_TYPES.PLAN_PRICE) {
          const { itemType, valueType, frequencyType } = restRuleParams
          const add = ['增加出价', '设置新出价', '减少出价']
          const sub = ['增加预算', '设置新预算', '减少预算']
          if (itemType) {
            if (params.ruleType === RULE_TYPES.PLAN_BUDGET) params.ruleTypeInfo.itemTypeName = sub[itemType - 1]
            else params.ruleTypeInfo.itemTypeName = add[itemType - 1]
          }
          valueType && (params.ruleTypeInfo.valueTypeName = ['元', '%'][valueType - 1])
          frequencyType && (params.ruleTypeInfo.frequencyTypeName = ['每天', '总共'][frequencyType - 1])
        }
      }

      if (params.rangeType === RANGE_TYPES.APP_LEVEL) {
        const { gameIds, gameGroupIds, mgameIds, gameType } = params.ruleTypeInfo
        params.ruleTypeInfo = {
          gameType
        }

        if (gameIds?.length) params.ruleTypeInfo.gameIds = gameIds.join(',')
        if (gameGroupIds?.length) params.ruleTypeInfo.gameGroupIds = gameGroupIds.join(',')
        if (mgameIds?.length) params.ruleTypeInfo.mgameIds = mgameIds.join(',')
      }

      const { emailFlag, sendOpIds } = this.monitor

      if (sendOpIds?.length) {
        params.sendOpIds = sendOpIds.join(',')
      } else {
        params.sendOpIds = ''
      }

      if (emailFlag.includes(RECIEVE_TYPES.DING) && emailFlag.includes(RECIEVE_TYPES.EMAIL)) {
        params.emailFlag = 3
      } else {
        if (emailFlag.includes(RECIEVE_TYPES.DING)) {
          params.emailFlag = 1
        }
        if (emailFlag.includes(RECIEVE_TYPES.EMAIL)) {
          params.emailFlag = 2
        }
      }

      if (emailFlag.includes(RECIEVE_TYPES.DING_GROUP) && this.dingWebhooks.filter((row) => row.url?.trim()).length) {
        params.webhookConfig = this.dingWebhooks.map((d) => d.url).join(',')
      }

      return params
    },

    // 验证表单
    async validateForm() {
      try {
        const valid = await this.$refs.monitorForm.validate()
        if (!valid) return false
        return true
      } catch (error) {
        console.error('表单验证失败:', error)
        return false
      }
    },

    // 处理提交响应
    handleSubmitResponse(data, isEdit = false) {
      this.loading = false
      this.show = true
      if (data) {
        this.$Message.success({
          closable: true,
          duration: 2,
          content: `${isEdit ? '编辑' : '提交'}成功！2秒后自动跳转`
        })
        timeout(3000).then(() => {
          this.jump()
        })
      }
    },

    // 提交表单
    async submit() {
      if (!(await this.validateForm())) return

      try {
        this.show = false
        this.loading = true
        const params = this.getFormData()
        const data = await createAutoRule(params)
        this.handleSubmitResponse(data)
      } catch (error) {
        this.loading = false
        this.show = true
        this.$Message.error({
          content: '提交失败，请重试',
          duration: 3
        })
        console.error('提交失败:', error)
      }
    },

    // 保存表单
    async save() {
      if (!(await this.validateForm())) return

      try {
        this.show = false
        this.loading = true
        const params = this.getFormData()
        const data = await editAutoRule(params)
        this.handleSubmitResponse(data, true)
      } catch (error) {
        this.loading = false
        this.show = true
        this.$Message.error({
          content: '保存失败，请重试',
          duration: 3
        })
        console.error('保存失败:', error)
      }
    },
    jump() {
      this.$router.push({ name: 'monitorules' })
    },
    cannel() {
      this.$confirm('关闭当前页面编辑信息将丢失，是否确定？', '确认', {
        type: 'warning'
      }).then(() => {
        this.jump()
      })
    },
    /**
     * @description: 清空全部已选游戏
     * @return {*}
     */
    onRemoveAllResult() {
      this.monitor.ruleTypeInfo.mgameIds = []
      this.monitor.ruleTypeInfo.gameGroupIds = []
      this.monitor.ruleTypeInfo.gameIds = []
    },
    /**
     * @description: 清除单条选中游戏
     */
    onRemoveGameItem(item) {
      const { key } = GAME_TYPE_LIST.find((m) => m.value === this.gameResultTab) || {}
      if (key) {
        this.monitor.ruleTypeInfo[key] = this.monitor.ruleTypeInfo[key].filter((id) => id !== item.id)
      }
    }
  },
  data() {
    const defaultOpId = Cookies.get('ch_op_id')
    return {
      show: null,
      gameResultTab: 1,
      gameSearchString: '',
      dingWebhooks: [{ url: '' }],
      monitor: {
        ruleId: this.$route.query.id,
        name: '',
        rangeType: RANGE_TYPES.ACCOUNT_LEVEL,
        mediaId: 10,
        monitorCondition: [],
        ruleType: 1,
        ruleTypeInfo: getRuleInfoForm(),
        emailFlag: ['1'],
        dataRange: 1,
        sendOpIds: [Number(defaultOpId)]
      },
      loading: null,
      monitorTime: 'half',
      daytime: '00:00',
      times: times, // 每半小时

      model: null,
      selecting: null, // 选择账号加载动画
      accounData: [],
      includeData: [],
      excludeData: [],
      planIds: [],
      excludePlanIds: [],
      accountIds: [],
      accounts: [],
      preload: false, // 预加载数据标识
      rules: {
        name: [
          { required: true, message: '请输入规则名称', trigger: 'blur' },
          { min: 2, max: 60, message: '长度在 2 到 60 个字符', trigger: 'blur' }
        ],
        game: [
          {
            validator: (rule, value, callback) => {
              const { gameIds, gameGroupIds, mgameIds } = this.monitor.ruleTypeInfo

              if (!gameIds?.length && !gameGroupIds?.length && !mgameIds?.length) {
                callback(new Error('游戏选择不能为空'))
              }
              callback()
            },
            trigger: ['change']
          }
        ],
        monitorTime: [
          {
            validator: (rule, value, callback) => {
              if (this.monitorTime === 'day' && !this.daytime) {
                callback(new Error('监测频率为每天时时间点为必填'))
                return
              }
              callback()
            },
            trigger: ['change']
          }
        ],
        monitorCondition: [
          {
            validator: (rule, value, callback) => {
              if (this.monitor.ruleType < 6) {
                const hasEmptyValue = value.some((ret) => isEmpty(ret.value))
                if (hasEmptyValue) {
                  callback(new Error('触发条件中的值验证不通过'))
                  return
                }

                const hasInvalidCost = value.filter((ret) => ret.key === 'newPayCost').some((ret) => ret.value >= 1000000)
                if (hasInvalidCost) {
                  callback(new Error('触发条件中新创角付费成本的值最大999999.99'))
                  return
                }
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ],
        ruleTypeInfo: [
          {
            validator: (rule, value, callback) => {
              if ([RULE_TYPES.PLAN_BUDGET, RULE_TYPES.PLAN_PRICE].includes(this.monitor.ruleType)) {
                if (!value.value) {
                  callback(new Error('规则项目不能为空'))
                  return
                }

                if (value.itemType !== 2 && !value.upperLimit) {
                  callback(new Error('调整规则的限制不能为空'))
                  return
                }

                // 预算验证
                if (this.monitor.ruleType === 3) {
                  if (value.itemType !== 2) {
                    if (value.upperLimit < 100 || value.upperLimit > 9999999) {
                      callback(new Error('调整规则的限制金额为100 ~ 9999999元，保留2位小数'))
                      return
                    }
                  }
                  if (value.valueType === 1 && (value.value < 100 || value.value > 9999999)) {
                    callback(new Error('调整规则的金额为100 ~ 9999999元，保留2位小数'))
                    return
                  }
                }

                // 出价验证
                if (this.monitor.ruleType === 4) {
                  if (value.itemType !== 2) {
                    if (value.upperLimit < 0.5 || value.upperLimit > 5000) {
                      callback(new Error('调整规则的限制金额为0.5 ~ 5000元，保留2位小数'))
                      return
                    }
                    if (value.valueType === 1 && (value.value < 0.1 || value.value > 300)) {
                      callback(new Error('调整规则的金额为0.1 ~ 300元，保留2位小数'))
                      return
                    }
                  } else if (value.itemType === 2 && value.valueType === 1 && (value.value < 0.5 || value.value > 1000)) {
                    callback(new Error('调整规则的金额为0.5 ~ 1000元，保留2位小数'))
                    return
                  }
                }

                // 百分比验证
                if (value.valueType === 2) {
                  if (value.itemType === 1 && (value.value <= 0 || value.value > 1000)) {
                    callback(new Error('调整规则的百分比为0.01 ~ 1000%，保留2位小数'))
                    return
                  } else if (value.itemType === 3 && (value.value <= 0 || value.value > 100)) {
                    callback(new Error('调整规则的百分比为0.01 ~ 100%，保留2位小数'))
                    return
                  }
                }
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ],

        emailFlag: [
          {
            validator: (rule, value, callback) => {
              if (!value?.length) {
                callback(new Error('请选择提醒方式'))
                return
              }
              callback()
            },
            trigger: ['change']
          }
        ],
        webhook: [
          {
            validator: (rule, value, callback) => {
              // 验证http url 地址
              const urlRegExp = /^(https?:\/\/(([a-zA-Z0-9]+-?)+[a-zA-Z0-9]+\.)+[a-zA-Z]+)(:\d+)?(\/.*)?(\?.*)?(#.*)?$/
              for (const item of this.dingWebhooks) {
                if (item?.url && !urlRegExp.test(item.url)) {
                  callback(new Error('请输入正确的webhook地址'))
                  return
                }
              }

              callback()
            }
          }
        ]
      }
    }
  },
  created() {
    if (this.monitor.ruleId) this.getData()
    else this.show = true
  }
}
</script>
<style lang="scss" scoped>
.auto-tasks-form {
  height: calc(100% - 40px);
  overflow: hidden;
  overflow-y: auto;

  .el-form {
    width: 1200px;
    margin: 0 auto;
    padding-top: 80px;
  }
}
.webhooks {
  .add-row {
    display: flex;
    p {
      margin-left: 10px;
      font-size: 12px;
      color: #999;
    }
  }
  .url-input {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    .close {
      cursor: pointer;
      &:hover {
        opacity: 0.7;
      }
    }
  }
}
@mixin block {
  height: 240px;
  background: #f6f6f6;
  border-radius: 4px;
}
.selector {
  display: flex;

  .lists {
    @include block;
    flex: 1;
    padding: 10px 0;
    .search-box {
      padding: 0 10px;
    }
    .checkbox-wrapper {
      height: 185px;
      overflow: auto;
      margin-top: 4px;
      padding-left: 10px;
      .checkbox-item {
        line-height: 12px;
        ::v-deep .el-checkbox {
          line-height: 12px;
        }
      }
    }
  }
}
</style>
